import useSWR from 'swr';
import { useMemo, useEffect } from 'react';
import {
  PreloadDataType,
  FullPreloadDataType,
  PreloadDataFetchType,
} from '@am3nd-org/pointcraft-types';

import { fetcher, apiEndpoints } from 'src/utils/axios';

import { useSystemStore } from 'src/store/SystemStore';

export function isFullPreloadData(data: PreloadDataType): data is FullPreloadDataType {
  return 'devices' in data && 'userData' in data;
}

export function useFetchAllData({ type }: { type: PreloadDataFetchType[] | null }) {
  const options = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  };
  const { setShouldRefetchPreload, shouldRefetchPreload } = useSystemStore.getState();
  const URL =
    type && type.length > 0
      ? `${apiEndpoints.server.preloadData}?fields=${type.join(',')}`
      : null;
  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcher, options);

  useEffect(() => {
    if (shouldRefetchPreload) {
      console.log('Azed Refetching preload data');
      mutate();
      setShouldRefetchPreload(false);
    }
  }, [shouldRefetchPreload, mutate, setShouldRefetchPreload]);

  const memoizedValue = useMemo(
    () => ({
      data: (data as PreloadDataType) || null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );
  return memoizedValue;
}
